import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoxArchive = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 14,
	viewBox: "0 0 16 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.5 0H1.5C0.65625 0 0 0.6875 0 1.5V3.5C0 3.78125 0.21875 4 0.5 4H1V12C1 13.125 1.875 14 3 14H13C14.0938 14 15 13.125 15 12V4H15.5C15.75 4 16 3.78125 16 3.5V1.5C16 0.6875 15.3125 0 14.5 0ZM14 12C14 12.5625 13.5312 13 13 13H3C2.4375 13 2 12.5625 2 12V4H14V12ZM15 3H1V1.5C1 1.25 1.21875 1 1.5 1H14.5C14.75 1 15 1.25 15 1.5V3ZM5.5 7H10.5C10.75 7 11 6.78125 11 6.5C11 6.25 10.75 6 10.5 6H5.5C5.21875 6 5 6.25 5 6.5C5 6.78125 5.21875 7 5.5 7Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgBoxArchive);
export { ForwardRef as ReactComponent };
